<template>
  <div class="header">
    <v-app-bar flat color="#eaebf4" app height="60">
      <v-toolbar-title class="d-flex align-center">
        <!-- <v-img
          :src="require('@/assets/images/logo-2.png')"
          class="header-logo"
          contain
          width="45px"
        /> -->
        <v-img
          v-if="currentRoute && currentRoute.clubLogoFileName"
          :src="fileURL + currentRoute.clubLogoFileName"
          class="header-logo"
          contain
          width="100px"
        />
        <!-- <div>
          <h3>سیستـــم مشتـــری</h3>
          <h6>مدیریت تخفیف و جایــزه</h6>
        </div> -->
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <!-- <v-tooltip top :open-on-focus="true">
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            class="me-2 p-pointer"
            style="transform: rotate(180deg);"
            @click="logoutCustomer"
          >
            mdi-exit-to-app
          </v-icon>
        </template>
        <span> خروج </span>
      </v-tooltip> -->
      <div class="complete-profile" @click="profile" v-if="showProfileBtn">
        <span> تکمیل پروفایل </span>
      </div>

      <AccountDropDown />
    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";
import AccountDropDown from "./dropDown/Account";

export default {
  name: "TheHeader",
  components: {
    AccountDropDown,
  },
  data() {
    return {
      alert,
      label,
      showProfileBtn: false,
      fileURL: this.RUNTIME_ENV.VUE_APP_FILE_URL,
    };
  },
  computed: {
    ...mapGetters({
      currentRoute: "routeName",
      userProfile: "currentUser",
      requirementProfileItem: "baseX/requirementProfile",
      postCheck: "postCheck",
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.isRequirement();
      }
    },
    requirementProfileItem() {
      this.isRequirement();
    },
  },

  methods: {
    profile() {
      this.$router.push({ name: "Profile" }).catch(() => {});
    },
    isRequirement() {
      if (
        (this.requirementProfileItem &&
          this.requirementProfileItem.isBirthDate == true &&
          this.userProfile.birthDateLocal == null) ||
        (this.requirementProfileItem &&
          this.requirementProfileItem.isFirstName == true &&
          this.userProfile.firstName == null) ||
        (this.requirementProfileItem &&
          this.requirementProfileItem.isGenderId == true &&
          this.userProfile.genderId == null) ||
        (this.requirementProfileItem &&
          this.requirementProfileItem.isLastName == true &&
          this.userProfile.lastName == null) ||
        (this.requirementProfileItem &&
          this.requirementProfileItem.isMaritalStatus == true &&
          this.userProfile.maritalStatus == null &&
          this.userProfile.marriageDateLocal == null) ||
        (this.requirementProfileItem &&
          this.requirementProfileItem.isMaritalStatus == true &&
          this.userProfile.maritalStatus == true &&
          this.userProfile.marriageDateLocal == null) ||
        (this.requirementProfileItem &&
          this.requirementProfileItem.isMarriageDate == true &&
          this.userProfile.maritalStatus == true &&
          this.userProfile.marriageDateLocal == null) ||
        (this.requirementProfileItem &&
          this.requirementProfileItem.isNationalCode == true &&
          this.userProfile.nationalCode == null)
      ) {
        this.showProfileBtn = true;
      } else {
        this.showProfileBtn = false;
      }
    },
  },
  mounted() {
    this.$store.dispatch("baseX/getRequirementProfile");
    this.$store.dispatch("getCurrentUser");
  },
};
</script>
